export const en = {
    'button-text': 'Bid'
};
